module.exports = __webpack_public_path__ + "0f41f09d1f82f752f3823cbc7ed6691d.otf";